import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const initAuth = async () => {
      const storedToken = localStorage.getItem('token');
      const savedUser = localStorage.getItem('user');
      
      if (storedToken && savedUser) {
        try {
          const response = await getMe();
          setUser(response.data);
          setToken(storedToken);
          setIsAuthenticated(true);
        } catch (error) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setUser(null);
          setToken(null);
          setIsAuthenticated(false);
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = (newToken, userData) => {
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(userData));
    setToken(newToken);
    setUser(userData);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // Clear admin mode context on logout
    sessionStorage.removeItem('selectedOrg');
    sessionStorage.removeItem('operatingMode');
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
  };

  const isSuperAdmin = () => user?.role === 'super_admin';
  const isOrgAdmin = () => ['super_admin', 'org_admin'].includes(user?.role);
  const isBroker = () => user?.role === 'broker';
  const isBrokerOrAdmin = () => ['super_admin', 'broker'].includes(user?.role);

  return (
    <AuthContext.Provider value={{
      user,
      token,
      loading,
      isAuthenticated,
      login,
      logout,
      isSuperAdmin,
      isOrgAdmin,
      isBroker,
      isBrokerOrAdmin,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
